<template>
  <div>
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="close()">
      </div>
      <div class="header-card-text">
        <h3>Investments</h3>
        <p class="sub-text fnt-14">Here are investment opportunities curated to meet your
        risk apetite</p>
      </div>
    </div>

    <div class="content">
      <div class="inv-header-tabs d-flex justify-content-between">
        <div class="text-center w-50" :class="[allTab ? 'active' : '']" @click="toggle('all')">
          <h4>All Investments</h4>
        </div>
        <div class="text-center w-50" :class="[myTab ? 'active' : '']" @click="toggle('myInv')">
          <h4>My Investments</h4>
        </div>
      </div>

      <div v-if="allTab">
        <div v-if="!invLoading">
          <div v-if="allInvestments.length >= 1">
            <div v-for="(inv, index) in allInvestments" :key="index"
            @click="openInvestment('f', inv.id)">
              <div class="investment-card" v-if="checkMastermind(inv.target)">
                <div class="first-col">
                  <p class="cabin-family bold">{{ inv.company }} - {{ inv.name }}</p>
                  <div class="d-flex justify-content-between" v-if="inv.percentage > 0">
                    <p class="black"><span class="bold primary">{{inv.percentage}}%</span> in
                    {{ inv.duration }} months</p>
                    <div class="cabin-family bold sold-out"
                    v-if="soldOut(inv.units, inv.sold_units)">Sold Out</div>
                  </div>
                  <p class="cabin-family" v-if="inv.amount > 0">
                  <span class="bold"><span v-if="inv.denomination == 'Naira'">₦</span>
                  <span v-else>$</span>
                  {{ checkMastermind(inv.target) }}</span></p>
                  <!-- <p class="cabin-family">Return on Investment:
                <span class="bold">₦ {{ calculateRoi(inv.amount, inv.percentage).toLocaleString() }}
                  </span></p> -->
                </div>
                <div class="second-col">
                  <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
                </div>
              </div>
              <div v-else>

              </div>
            </div>
          </div>
          <div v-else class="empty">
          <h5 class="secondary cabin-family" v-if="riskProfile">There are currently no live
          investments,<br> Please check back later.</h5>
          <h5 class="secondary cabin-family" v-else> Kindly take the risk profile assessment test
          <router-link to="/">here </router-link>
          so we can provide you Investment opportunities that suit your taste</h5>
          </div>
         </div>
         <div v-else class="empty">
           <vue-loaders-ball-spin-fade-loader scale=".5" color="red">
              </vue-loaders-ball-spin-fade-loader>
         </div>
      </div>

      <div v-else>
        <div v-if="myInvestments.length >= 1">
          <div class="investment-card" v-for="(inv, index) in myInvestments" :key="index"
          @click="openInvestment('t', inv.id)">
            <div class="first-col">
            <p class="cabin-family bold">{{ inv.investment.company }} - {{ inv.investment.name }}
            </p>
              <p v-if="inv.investment.percentage > 0" class="black">
              <span class="bold primary">{{inv.investment.percentage}}%</span> in
              {{ inv.investment.duration }} months</p>
              <p class="cabin-family">
              <span class="bold">
              <span v-if="inv.investment.denomination == 'Naira'">₦</span>
              <span v-if="inv.investment.denomination == 'Pounds'">￡</span>
              <span v-if="inv.investment.denomination == 'Dollar'">$</span>
              {{ Number(inv.amount).toLocaleString() }}</span></p>
              <p class="cabin-family" v-if="matured(inv.maturity_date)">
              <span class="bold primary">Matured</span></p>
              <p class="sub-text primary" v-if="inv.investment.denomination == 'Dollar'">
              **USD investments are currently calculated at ₦500/$1</p>
            </div>
            <div class="second-col">
              <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
            </div>
          </div>
        </div>
        <div v-else class="empty">
            <h5 class="secondary cabin-family">Investments Not available</h5>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    riskProfile() {
      if (this.risk_appetite && this.risk_appetite > 0) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      allInvestments: {},
      myInvestments: {},
      allTab: true,
      myTab: false,
      invLoading: false,
      risk_appetite: 0,
      userType: '',
    };
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.userType = user.user_type;
    this.getInvestments();
    this.risk_appetite = localStorage.getItem('risk_appetite');
  },
  methods: {
    async getInvestments() {
      this.invLoading = true;
      const url = `${this.$baseUrl}/investments`;
      const url1 = `${this.$baseUrl}/user/investments`;
      const res = await this.$http({ url, method: 'GET' });
      const res1 = await this.$http({ url: url1, method: 'GET' });
      this.myInvestments = res1.data.transactions;
      const all = res.data.investments;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < all.length; i++) {
        // eslint-disable-next-line no-plusplus
        for (let j = 0; j < this.myInvestments.length; j++) {
          if (all[i].id === this.myInvestments[j].investment_id) {
            all.splice(i, 1);
          }
        }
      }
      this.invLoading = false;
      this.allInvestments = all;
    },
    checkMastermind(invType) {
      if (invType === 'masterminds') {
        if (this.userType === 'mastermind') {
          return true;
        }
        return false;
      }
      return true;
    },
    openInvestment(trans, id) {
      this.$router.push(`investment/${trans}/${id}`);
    },
    soldOut(units, sold) {
      if (units <= sold) {
        return true;
      }
      return false;
    },
    toggle(tab) {
      if (tab === 'all') {
        this.allTab = true;
        this.myTab = false;
      } else {
        this.allTab = false;
        this.myTab = true;
      }
    },
    calculateRoi(amount, percentage) {
      const profit = amount * (percentage / 100);
      const total = amount + profit;
      return total;
    },
    close() {
      this.$router.go(-1);
    },
    matured(matDate) {
      const currentDate = new Date();
      const maturityDate = new Date(matDate);
      if (currentDate >= maturityDate) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .empty{
    text-align: center;
    margin: 4rem auto;
  }
  .sub-text{
    font-size: 12px;
    line-height: 14px;
    font-weight: 300;
    font-family: 'Roboto', sans-serif;
  }
  .inv-header-tabs{
    margin-bottom: 2rem;
    .active{
      border-bottom: 3px solid #EE0E4C;
    }
  }
  a {
    color: #EE0E4C;
  }
</style>
